//viewQuotation
import React, { useEffect } from "react";
import { BASE_URL } from "../../global";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToWords } from "to-words";
import HelpIcon from "@mui/icons-material/Help";
import {
  Grid,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Autocomplete,
  TableContainer,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import "./viewQuotation.css";

import { viewQuotationGuide } from "./guide";
import { fetchAddresses } from "../invoice/productDetails";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ErrorModal from "../../utils/components/errorModal";
import CustomPDFViewer from "../trainingResources/CustomPDFViewer";
import { generatePDF1 } from "./quotationPrint";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "1px solid black",
      fontSize:"11.5px",
      fontFamily: "Times New Roman",
    },
  },
  row: {
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  cell: {
    padding: 1,
    width: 180,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  cell50: {
    padding: 1,
    width: "50%",
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  signCell: {
    padding: 1,
    width: 30,
    alignItems: "center",
    fontStyle: "bold",
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  srCell: {
    padding: 1,
    width: 50,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },

  nameCell: {
    padding: 1,
    width: 130,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  makeCell: {
    padding: 1,
    width: 100,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  rangeCell: {
    padding: 1,
    width: 50,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  qntCell: {
    padding: 1,
    width: 30,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  rateCell: {
    padding: 1,
    width: 50,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  boldCss: {
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  termsboldCss: {
    fontSize:"10.5px",
    fontFamily: "Times New Roman",
  },
  totalCell: {
    padding: 1,
    width: 130,
    height: 5,
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
  spacialCaseBorder: {
    borderBottom: "1px solid black !important",
    fontSize:"11.5px",
    fontFamily: "Times New Roman",
  },
});

function InstrumentTable({
  classes,
  quotationProductDetails,
  productList1,
  quotationAllData,
}) {
  const toWords = new ToWords();
  let productDeatails = quotationProductDetails;
  let productList = productList1;
  const hasDiscount =
    Array.isArray(productDeatails) &&
    productDeatails?.some((product) => product?.discount !== null);

  var amounts = {
    totalAmountBeforeTax: 0,
    gst: 0,
    sgst: 0,
    cgst: 0,
    conveyanceCharges: 0,
    courierCharges: 0,
    grandTotal: 0,
    discount: 0,
    totalAmountbeforediscount: 0,
  };

  if (productDeatails.length > 0 && productList.length > 0) {
    for (let i = 0; i < productDeatails.length; i++) {
      const result = productList.find(
        ({ id }) => id === productDeatails[i].equipmentId
      );
      productDeatails[i].name = result?.instrumentName;
      let totalAmount = productDeatails[i].rate * productDeatails[i].quantity;
      let discountAmount =
        (totalAmount * (parseFloat(productDeatails[i]?.discount) || 0)) / 100;
      productDeatails[i].amount = totalAmount - discountAmount;
      amounts.totalAmountBeforeTax += productDeatails[i].amount;
    }
    amounts.conveyanceCharges = parseInt(
      quotationAllData[0]?.conveyanceCharges
        ? quotationAllData[0]?.conveyanceCharges
        : "0"
    );
    amounts.courierCharges = parseInt(
      quotationAllData[0]?.courierCharges
        ? quotationAllData[0]?.courierCharges
        : "0"
    );
    amounts.totalAmountBeforeTax +=
      amounts.conveyanceCharges + amounts.courierCharges;

    amounts.totalAmountbeforediscount = amounts.totalAmountBeforeTax;
    amounts.discount = quotationAllData[0]?.discount;
    let discountcal = (amounts.totalAmountBeforeTax * amounts.discount) / 100;

    amounts.totalAmountBeforeTax = amounts.totalAmountBeforeTax - discountcal;

    const gstType = quotationAllData[0]?.gstType;
    const gstPercentages = quotationAllData[0]?.gstpercentages;

    if (gstType === 1) {
      const percentage = gstPercentages ? gstPercentages / 2 : 9;
      amounts.sgst = amounts.cgst =
        (amounts.totalAmountBeforeTax * percentage) / 100;
      amounts.gst = amounts.sgst + amounts.cgst;
    } else if (gstType === 2) {
      amounts.gst =
        (amounts.totalAmountBeforeTax * (gstPercentages || 18)) / 100;
    } else {
      amounts.gst = 0;
    }
    amounts.grandTotal = amounts.gst + amounts.totalAmountBeforeTax;
  }

  return (
    <Table mt={5} className={["single-border-table", classes.table]}>
      <TableRow style={{ backgroundColor: "rgba(156,194,230,255)" }} id="pagbreaksborder">
        <TableCell className={classes.srCell} align="center">
          <b className={classes.boldCss}>Sr. No</b>
        </TableCell>
        <TableCell className={classes.nameCell} align="center">
          <b className={classes.boldCss}>Description of Item</b>
        </TableCell>
        <TableCell className={classes.nameCell} align="center">
          <b className={classes.boldCss}>Range/Capacity</b>
        </TableCell>
        {/* <TableCell className={classes.makeCell} align="center">
          <b className={classes.boldCss}>SAC | HSN Code Job Type</b>
        </TableCell> */}
        <TableCell className={classes.rangeCell} align="center">
          <b className={classes.boldCss}>Type of Service</b>
        </TableCell>
        <TableCell className={classes.rangeCell} align="center">
          <b className={classes.boldCss}>Rate</b>
        </TableCell>
        <TableCell className={classes.qntCell} align="center">
          <b className={classes.boldCss}>Quantity (No)</b>
        </TableCell>
        {hasDiscount && (
          <TableCell className={classes.qntCell} align="center">
            <b className={classes.boldCss}>Discount (%)</b>
          </TableCell>
        )}
        <TableCell className={classes.rateCell} align="center">
          <b className={classes.boldCss}>Total Price (INR)</b>
        </TableCell>
      </TableRow>
      {productList &&
        productDeatails?.map((product, i) => (
          <TableRow className={classes.row} key={i} id="pagbreaksborder">
            <TableCell className={classes.srCell} align="center">
              {i + 1}
            </TableCell>
            <TableCell className={classes.nameCell} align="center">
              {product?.requestedName ? product?.requestedName : product?.name}
            </TableCell>
            <TableCell className={classes.nameCell} align="center">
            {product?.rangeValue?.replace(/#/g, ' ')?.replace(/\|/g, ' to ')?.replace(/\s+/g, ' ')?.trim()}  &nbsp;   {product?.description}
            </TableCell>
            {/* <TableCell className={classes.makeCell} align="center">
              {product?.hsnCode}
            </TableCell> */}
            <TableCell className={classes.rangeCell} align="center">
              {product?.service}
            </TableCell>
            <TableCell className={classes.qntCell} align="center">
              {product?.rate?.toFixed(2)}
            </TableCell>
            <TableCell className={classes.rateCell} align="center">
              {product?.quantity}
            </TableCell>
            {hasDiscount ? (
              product?.discount !== null ? (
                <TableCell className={classes.rateCell} align="center">
                  {product?.discount} %
                </TableCell>
              ) : (
                <TableCell
                  className={classes.rateCell}
                  align="center"
                ></TableCell>
              )
            ) : null}
            <TableCell className={classes.rateCell} align="center">
              {product?.amount?.toFixed(2)}
            </TableCell>
          </TableRow>
        ))}
      {amounts.conveyanceCharges !== 0 && (
        <TableRow id="pagbreaksborder">
          <TableCell
            className={classes.nameCell}
            colSpan={hasDiscount ? 7 : 6}
            align="right"
          >
            <b className={classes.boldCss}>Onsites Charges &nbsp;</b>
          </TableCell>
          <TableCell className={classes.rateCell} align="center">
            <b className={classes.boldCss}>
              {" "}
              {amounts.conveyanceCharges
                ? amounts.conveyanceCharges?.toFixed(2)
                : 0}
            </b>
          </TableCell>
        </TableRow>
      )}
      {amounts.courierCharges !== 0 && (
        <TableRow id="pagbreaksborder">
          <TableCell
            className={classes.nameCell}
            colSpan={hasDiscount ? 7 : 6}
            align="right"
          >
            <b className={classes.boldCss}> Courier Charges &nbsp;</b>
          </TableCell>
          <TableCell className={classes.rateCell} align="center">
            <b className={classes.boldCss}>
              {amounts.courierCharges ? amounts.courierCharges?.toFixed(2) : 0}
            </b>
          </TableCell>
        </TableRow>
      )}
       <TableRow id="pagbreaksborder">
        <TableCell
          className={classes.nameCell}
          colSpan={hasDiscount ? 7 : 6}
          align="right"
        >
          <b className={classes.boldCss}>Total Amount &nbsp;</b>
        </TableCell>
        <TableCell className={classes.rateCell} align="center">
          <b className={classes.boldCss}>{amounts.totalAmountbeforediscount?.toFixed(2)}</b>
        </TableCell>
      </TableRow>
      {amounts?.discount ? (
        <TableRow id="pagbreaksborder">
          <TableCell
            className={classes.nameCell}
            colSpan={hasDiscount ? 7 : 6}
            align="right"
          >
            <b className={classes.boldCss}>Discount&nbsp;</b>
          </TableCell>
          <TableCell className={classes.rateCell} align="center">
            <b className={classes.boldCss}>{amounts?.discount ? `${amounts?.discount} %` : ""}</b>
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
       {amounts?.discount && (
      <TableRow id="pagbreaksborder">
        <TableCell
          className={classes.nameCell}
          colSpan={hasDiscount ? 7 : 6}
          align="right"
        >
          <b className={classes.boldCss}>Total Amount After Discount &nbsp;</b>
        </TableCell>
        <TableCell className={classes.rateCell} align="center">
          <b className={classes.boldCss}>{amounts.totalAmountBeforeTax?.toFixed(2)}</b>
        </TableCell>
      </TableRow>
      )}
      {quotationAllData?.[0]?.gstType === 1 && (
        <>
          <TableRow id="pagbreaksborder">
            <TableCell
              className={classes.nameCell}
              colSpan={hasDiscount ? 7 : 6}
              align="right"
            >
              <b className={classes.boldCss}>{`CGST(${(quotationAllData?.[0]?.gstpercentages || 18) / 2}%) `}</b>
            </TableCell>
            <TableCell className={classes.rateCell} align="center">
              <b className={classes.boldCss}>{(amounts?.gst / 2)?.toFixed(2)}</b>
            </TableCell>
          </TableRow>
          <TableRow id="pagbreaksborder">
            <TableCell
              className={classes.nameCell}
              colSpan={hasDiscount ? 7 : 6}
              align="right"
            >
              <b className={classes.boldCss}>{`SGST(${(quotationAllData?.[0]?.gstpercentages || 18) / 2}%) `}</b>
            </TableCell>
            <TableCell className={classes.rateCell} align="center">
              <b className={classes.boldCss}>{(amounts?.gst / 2)?.toFixed(2)}</b>
            </TableCell>
          </TableRow>
        </>
      )}
      {(quotationAllData?.[0]?.gstType === 2 ) && (
        <>
          <TableRow id="pagbreaksborder">
            <TableCell
              className={classes.nameCell}
              colSpan={hasDiscount ? 7 : 6}
              align="right"
            >
              <b className={classes.boldCss}>{`IGST(${quotationAllData?.[0]?.gstpercentages || 18}%) `}</b>
            </TableCell>
            <TableCell className={classes.rateCell} align="center">
              <b className={classes.boldCss}>{amounts.gst?.toFixed(2)}</b>
            </TableCell>
          </TableRow>
        </>
      )}
      <TableRow style={{ backgroundColor: "rgba(156,194,230,255)" }} id="pagbreaksborder">
        <TableCell
          className={classes.nameCell}
          colSpan={hasDiscount ? 7 : 6}
          align="right"
        >
          <b className={classes.boldCss}>Grand Total Amount &nbsp;</b>
        </TableCell>
        <TableCell className={classes.rateCell} align="center">
          <b className={classes.boldCss}>{amounts.grandTotal ? amounts.grandTotal?.toFixed(2) : ""}</b>
        </TableCell>
      </TableRow>
      <TableRow id="pagbreaksborder">
        <TableCell
          className={classes.nameCell}
          colSpan={hasDiscount ? 8 : 7}
          align="left"
        >
          <div>
            <b style={{  padding: "1px 5px" }}>
              &nbsp; Amount in Words:
            </b>
            <b className={classes.boldCss}>
              &nbsp;
              {toWords.convert(
                amounts.grandTotal ? amounts.grandTotal?.toFixed(2) : 0,
                { currency: true }
              )}
            </b>
          </div>
        </TableCell>
      </TableRow>
    </Table>
  );
}

export default function EditQuotation() {
  const viewQuotationGuides = viewQuotationGuide();
  const printComponentRef = React.useRef();
  const classes = useStyles();
  const params = useParams();
  let loginName = localStorage.getItem("userName") || "";
  const [productList, setProductList] = React.useState([]);
  const [asPerAttach, setAsPerAttach] = React.useState(false);
  const [details, setDetails] = React.useState({
    companyName: "",
    companyNumber: "",
    clientName: "",
    address: "",
    referenceNumber: "",
    quotationNumber: "",
    subject: "",
    Date: "",
    thankYouForEnquiry: "",
    termsConditions: "",
    clientId: "",
    conveyanceCharges: "",
    gstNumber: "",
    email: "",
  });
  const [quotationProductDetails, setProductDetails] = React.useState([]);
  const [quotationAllData, setquotatioAllData] = React.useState([]);
  const [settings, setSettings] = React.useState({});
  const [letterHead, setLetterHead] = React.useState(true);
  const [electronicSign, setElectronicSign] = React.useState(true);
  const [contact, setContact] = React.useState({
    contname: "",
    email: "",
    contactNumber: "",
  });
  const [newAddressArray, setNewAddressArray] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const [headingType, setHeadingType] = React.useState("QUOTATION FOR CALIBRATION & TESTING SERVICES");

  const openErrorModal = (errorMessage,stackTrace,fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };
  const [letterHeadCompnayType, setLetterHeadCompnayType] = React.useState(true);

  function fetchSettings() {
    axiosWithToken.get(BASE_URL + `settings?_where=(status,eq,1)`).then((res) => {
      let _settingList = {};
      res.data.forEach((setting) => {
        _settingList[setting.keyName] = setting.value;
      });
      setSettings(_settingList);
    }).catch((err)=>{
      if (err.message !== "request_aborted") {
        toast.error(<h6 onClick={() => openErrorModal(err.message, "fetchSettings" ,"View Quotation")}><u>Error: {err.message}</u></h6>);
      }
    })
  }
  const getProductList = () => {
    let url = BASE_URL;
    const payload = {
      query:
        "select cp.*, ins.instrumentName from instrumentPriceList as cp left join instruments as ins on cp.instrumentId=ins.id;",
    };
    axiosWithToken
      .post(url + "dynamic", payload)
      .then((res) => {
        setProductList(res.data);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "getProductList" ,"View Quotation")}><u>Error: {err.message}</u></h6>);
        }
      });
  };

  const getQuat = () => {
    let url = BASE_URL;
    let paylaod = {
      query: `SELECT qt.*,qt.address as qt_address,qt.id as qt_id, client.* FROM quotation AS qt JOIN clients AS client ON qt.clientId = client.id WHERE qt.status = 1 and qt.clientId = ${params.clientId} AND qt.quotationNumber LIKE '${params.quotationNumber}'`,
    };
    axiosWithToken
      .post(url + "dynamic", paylaod)
      .then(async (res) => {
        let sqlQuery = {
          query: `SELECT * FROM productDetails WHERE status = 1 and type = 1 AND referenceId = ${res.data[0]?.qt_id}`,
        };
        const response = await axiosWithToken.post(
          BASE_URL + `dynamic`,
          sqlQuery
        );
        setProductDetails(response.data);
        let contact = res.data[0].contact
          ? JSON.parse(res.data[0].contact)
          : null;
        setquotatioAllData(res.data);
        let contactPerson = contact?.find(
                (val) => val.contactPersonName === res.data[0]?.contactPersonDetails
              ) || {};
        
        setContact({
          contname: contact && contactPerson?.contactPersonName || "",
          email: contact && contactPerson?.emailId || "",
          contactNumber: contact && contactPerson?.contact || "",
        });
      })
      .catch((err) => {
        console.log("getquat", err);
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "getQuat" ,"View Quotation")}><u>Error: {err.message}</u></h6>);
        }
      });
  };
  useEffect(() => {
    // getQuotations();
    fetchSettings();
    getProductList();
    getQuat();
  }, []);

  useEffect(async () => {
    let splitAddress = quotationAllData[0]?.qt_address?.split(",");
    let newAddressArray = await fetchAddresses(
      splitAddress?.[0],
      splitAddress?.[1]
    );
    setNewAddressArray(newAddressArray);
  }, [quotationAllData[0]?.qt_address]);

  return (
    <>
      <Paper sx={{ mx: 1, p: 2 }}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Tooltip title="User Guide" placement="top-start">
            <Button
              onClick={() => {
                viewQuotationGuides.drive();
              }}
            >
              <HelpIcon />
            </Button>
          </Tooltip>
        </div>
        <Grid container spacing={2} align="left" style={{ display: "flex" }}>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Autocomplete
              size="small"
              id="quotation_view_letterhead"
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="letterHead" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Letter Head" ||
                  newInputValue === ""
                ) {
                  setLetterHead(true);
                } else if (newInputValue === "Without Letter Head") {
                  setLetterHead(false);
                }
                // newInputValue == "Approve" ? setEnableDisable() : setEnableDisable(4+':'+result.toString());
              }}
            />
          </Grid>
          {settings["InvAndQutLetterHead"] && settings["InvAndQutLetterHead"] == "true" && (
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Autocomplete
              size="small"
              options={[
                { id: 1, label: "Old" },
                { id: 2, label: "New" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Select LetterHead Type" />
              )}
              onInputChange={(event, newInputValue) => {
                if (newInputValue === "Old" || newInputValue === "") {
                  setLetterHeadCompnayType(true);
                } else if (newInputValue === "New") {
                  setLetterHeadCompnayType(false);
                }
              }}
            />
          </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Autocomplete
              size="small"
              id="quotation_view__electronicsign"
              options={[
                { id: 1, label: "With Electronically Signed" },
                { id: 2, label: "Without  Electronically Signed" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Electronically Signed" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Electronically Signed" ||
                  newInputValue === ""
                ) {
                  setElectronicSign(true);
                } else if (newInputValue === "Without  Electronically Signed") {
                  setElectronicSign(false);
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
                  <Autocomplete
                    size="small"
                    options={[
                      { id: 1, label: "As per attached list" },
                    ]}
                    renderInput={(params) => (
                      <TextField {...params} label="As per attached list" />
                    )}
                    onInputChange={(event, newInputValue) => {
                      if (
                        newInputValue === "As per attached list" ||
                        newInputValue === ""
                      ) {
                        setAsPerAttach(true);
                      }
                    }}
                  />
                </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Button
              id="quotation_view_Download"
              variant="contained"
              size="small"
              disabled={!(editAccess?.includes(3) || editAccess?.includes(0))}
                onClick={() =>
                                generatePDF1({
                                  headingType : quotationAllData[0]?.quotationType || headingType,
                                  letterHeadCompnayType,
                                  quotationProductDetails,
                                  productList,
                                  quotationAllData,
                                  newAddressArray,
                                  contact,
                                  settings,
                                  letterHead
                                })
                              }
            >
              Download PDF
            </Button>
          </Grid>
        </Grid>
        <br />
        <div
          className="invoice"
          ref={printComponentRef}
          id="quotation_view__print"
        >
          {quotationAllData ? (
            <div
              style={{
                width: "95%",
                // border: "1px solid black",
                textAlign: "center",
                margin: "0px auto",
                padding: "10px 10px 0px",
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  md={12}
                  className="font-link"
                  align="center"
                  justifyContent={"center"}
                >
                  <h5 style={{ color: "#000066", margin: "5px 0px" }}>
                    <b className={classes.boldCss}>{quotationAllData[0]?.quotationType || headingType} SERVICES</b>
                  </h5>
                </Grid>
              </Grid>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650, fontSize: "0.875rem", fontWeight: 400 }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableBody>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          width: "22%",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>Customer</b>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ width: "28%", borderRight: "none" }}
                      >
                        {quotationAllData[0]?.companyName}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          width: "22%",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>Enquiry ID | Date</b>
                      </TableCell>
                      <TableCell align="left" style={{ width: "28%" }}>
                      {quotationAllData[0]?.enquiryId ? `${quotationAllData[0]?.enquiryId} | ` :""}{moment(quotationAllData[0]?.enquiryDate).format(
                          "DD/MM/YYYY"
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          width: "22%",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>Billing Address</b>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ width: "28%", borderRight: "none" }}
                      >
                        {newAddressArray?.[0]?.address}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          width: "22%",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>Quotation Number | Date</b>
                      </TableCell>
                      <TableCell align="left" style={{ width: "28%" }}>
                        {quotationAllData[0]?.quotationNumber ? `${quotationAllData[0]?.quotationNumber} | ` : "" + (quotationAllData[0]?.revisionNumber > 0 ? `-Rev-${quotationAllData[0]?.revisionNumber}` : "") } {" "}
                        {moment(quotationAllData[0]?.date).format("DD/MM/YYYY")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          width: "22%",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>Contact Person</b>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ width: "28%", borderRight: "none" }}
                      >
                        {contact?.contname}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          borderRight: "none",
                          width: "22%",
                        }}
                      >
                        <b className={classes.boldCss}>Contact Number</b>
                      </TableCell>
                      <TableCell align="left" style={{ width: "28%" }}>
                        {contact?.contactNumber}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>E-mail</b>
                      </TableCell>
                      <TableCell align="left" style={{ borderRight: "none" }}>
                        {contact?.email}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          // backgroundColor: "#D9D9D9",
                          borderRight: "none",
                        }}
                      >
                        <b className={classes.boldCss}>Quotation Validity</b>
                      </TableCell>
                      <TableCell align="left">
                        30 Days
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          backgroundColor: "#D9D9D9",
                          borderRight: "none",
                        }}
                      >
                        <b>{newAddressArray?.[0]?.shipping?.address ? (
                          <b>Shipping Address</b>
                        ) : (
                          ""
                        )}</b>
                      </TableCell>
                      <TableCell align="left" style={{ borderRight: "none" }}>
                      {newAddressArray?.[0]?.shipping?.address}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          backgroundColor: "#D9D9D9",
                          borderRight: "none",
                        }}
                      >
                        <b>Quotation Validity</b>
                      </TableCell>
                      <TableCell align="left">
                        30 Days
                      </TableCell>
                    </TableRow> */}
                    {/* <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          backgroundColor: "#D9D9D9",
                          borderRight: "none",
                        }}
                      >
                        {newAddressArray?.[0]?.shipping?.address ? (
                          <b>Shipping Address</b>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          borderRight: "none",
                        }}
                      >
                        {newAddressArray?.[0]?.shipping?.address}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#D9D9D9",
                          borderRight: "none",
                        }}
                      >
                        <b>Equipment Collection</b>
                      </TableCell>
                      <TableCell align="left">
                        {quotationAllData[0]?.equipmentCollection}
                      </TableCell>
                    </TableRow> */}
                  </TableBody>
                </Table>
              </TableContainer>

              <div
                style={{
                  // backgroundColor: "#D9D9D9",
                  textAlign: "left",
                  border: "1px solid black",
                  padding: "3px 10px",
                  display: "flex",
                  gap: "0px",
                  flexDirection: "column",
                  fontSize: "13px",
                  borderBottom: "none",
                }}
              >
                <b className={classes.boldCss}>Respected Sir/Madam:</b>
                <b style={{ fontWeight: 500 }} className={classes.boldCss}>
                With reference to above mentioned subject, Please find enclosed herewith our offer as under to suit your requirement:
                </b>
                {/* <b>
                  Enquiry: +91 98406 72352 | Quotation: +91 99405 64783 |
                  Operations: +91 99400 47321
                </b> */}
              </div>

              {asPerAttach && (
                <table
                  style={{
                    width: "100%",
                    margin: "0px auto",
                    fontSize: "13px",
                  }}
                  className="srftable"
                >
                  <thead>
                    <tr>
                      <th colSpan={11} style={{ padding: "5px" , borderBottom:"none"}}>
                        <b>QUOTATION DETAILS AS PER ATTACHED LIST</b>
                      </th>
                    </tr>
                  </thead>
                </table>
              )}

              <InstrumentTable
                classes={classes}
                quotationProductDetails={quotationProductDetails}
                productList1={productList}
                quotationAllData={quotationAllData}
              ></InstrumentTable>              

              <div
                style={{
                  fontSize: "13px",
                  // pageBreakInside: "avoid",
                  paddingTop: "2px",
                }}
              >
                <div className="font-link-footer">
                  <h6>
                    <b className={classes.boldCss}>Standard Terms & Conditions</b>
                  </h6>
                  <div
                    style={{
                      whiteSpace: "pre-wrap",
                      padding: "1px 5px",
                      textAlign: "justify",
                    }}
                  >
                    {/* {quotationAllData[0]?.termsConditions ||
                      settings["quotation terms"]} */}
                      <ul style={{paddingLeft:"5px"}} className={classes.boldCss}>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid",fontSize:"15px"}}>
                                <b className={classes.boldCss}>Add-on Features of our Service Offering:</b>
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              a) Our calibration laboratories are accredited as per ISO/IEC 17025:2017 (NABL-India) for the Mechanical (Dimensional, Pressure, Mass, Volume, etc.); Electro-Technical and Thermal inclusive of humidity parameter.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              b) Pickup and Delivery service will be under customer scope.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              c) Quick Turnaround time – max 5 working days which can be further shortened with prior appointment/schedule.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              d) Repair/ servicing facility for majority of measuring instruments through our dedicated service partners.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              e) We can extend our support during your quality audits and can attend to queries related to calibration on your behalf as your trusted partner.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              f) We also arrange out of scope calibration from accredited Third Party Calibration Laboratories as an add-on service. Archerchem Calibrations will work as Single Point Contact for your all calibration needs.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                            g) Charges will be applicable as decided when found an instrument is defective/out of tolerance/ hysteresis error while calibrating.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid",fontSize:"15px"}}>
                            <b className={classes.boldCss}>Commercial Terms & Conditions:</b> 
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              1) Calibration Charges - The price indicated is applicable only for calibration and any additional service like repair / servicing, will be charged extra.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              2) GST - Goods and Services Tax (GST) @ 18 % will be charged extra on the total billing. (if any other taxes applicable at the time of billing, are in the scope of customer)
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              3) Payment - 100% in advance through DD/ Cheque in favour of Archercal Pvt. Ltd.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              4) Delivery (In house) – In five working days along with calibration certificate.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              5) Delivery (On-site) – All certificates will be issued in five working days after completion of site work.
                            </li>
                            <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              6) Dispatch by courier: The instruments will be sent on “COD basis only” and packing material will be used as received from customer.
                            </li>
                              <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              <b style={{fontSize:"13px"}}>Note - </b>
                              Archercal Pvt. Ltd. shall not be held responsible for any damage or loss of the instruments during calibration or in transit irrespective of the fact that required care will be taken while calibration/packing. You may provide Transit insurance for your instruments while sending for calibration.
                              </li>
                              <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>
                              <b style={{fontSize:"13px"}}>Special Note :</b> We hope you will find our offer competitive and in line with your requirement. Should you have any further queries or clarifications, please feel free to contact us on +91-9821596569.Thanking you and assuring you our best services always, we remain,
                              </li>
                              <li className={classes.boldCss} style={{pageBreakInside: "avoid",fontSize:"15px"}}>
                                <b className={classes.boldCss}>
                              Thanking you and assuring you our best services always, we remain.
                                </b>
                              </li>
                                <li className={classes.boldCss} style={{pageBreakInside: "avoid"}}>Please send your instrument details duly filled with Service Request Form.
                                </li>
                      </ul>
                                <div style={{pageBreakInside:"avoid"}}>
                                <ul style={{paddingLeft:"5px"}} className={classes.boldCss}>
                                <li className={classes.boldCss} style={{pageBreakInside: "avoid",textAlign:"right",fontSize:"15px"}}><b className={classes.boldCss}>Yours Sincerely,</b></li>
                                <li className={classes.boldCss} style={{pageBreakInside: "avoid",textAlign:"right",fontSize:"15px"}}><b className={classes.boldCss}>
                                  For Archercal Private Limited (Formerly known as Archerchem Calibrations Pvt Ltd)
                                  </b>
                                </li>
                                <li className={classes.boldCss} style={{pageBreakInside: "avoid",textAlign:"right",fontSize:"15px",textTransform:"capitalize"}}><b className={classes.boldCss}>
                                ( {loginName} ) 
                                  </b>
                                </li>
                                </ul>
                                </div>
                  </div>
                </div>
              </div>

                {asPerAttach && (
                  <ResourceModel
                resourceUrl={quotationAllData[0]?.fileUpload}
                />
                )}
            </div>
          ) : (
            <div>Loading...</div>
          )}

          <div style={{ width: "100%" }} id="header-section"></div>
        </div>
        {downloadPdfloading && (
          <DownloadPdfLoaderModal
            loading={downloadPdfloading}
            name={"Quotation"}
          />
        )}
          {errormodalIsOpen && <ErrorModal errormodalIsOpen={errormodalIsOpen} closeErrorModal={closeErrorModal} errorMessage={errorMessage} />}
      </Paper>
    </>
  );
}

function ResourceModel({ resourceUrl }) {
  const isPDF = resourceUrl && resourceUrl?.endsWith(".pdf");
  const isImage =
    resourceUrl &&
    (resourceUrl?.endsWith(".jpg") ||
      resourceUrl?.endsWith(".jpeg") ||
      resourceUrl?.endsWith(".png"));

  return (
    <div style={{ margin: "3px", pageBreakBefore:"always" }}>
        <WatermarkedContent>
        {isPDF ? (
          <CustomPDFViewer url={resourceUrl} height="100%" canvasHeight={"900px"} />
        ) : isImage ? (
          <img
            src={resourceUrl}
            alt="Resource"
            style={{ width: "100%", height: "100%" }}
          />
        ) : null // Return null for unsupported resource types
        }
        </WatermarkedContent>
    </div>
  );
}

const WatermarkedContent = ({ children }) => {
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {children}
    </div>
  );
};